import { render, staticRenderFns } from "./EventsIcon.vue?vue&type=template&id=b68b8d90&"
import script from "./EventsIcon.vue?vue&type=script&lang=js&"
export * from "./EventsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports